class CartTool extends HTMLElement {


  constructor() {


    super();


    const buttons = this.querySelectorAll('.cartTool-item');


    buttons.forEach((button) => {


      button.addEventListener('click',(event) => {


        const id = event.target.dataset.popup;


        document.getElementById(id).classList.add('show');


        document.querySelector('.previewCart').classList.add('active-tool');


      })


    })


  }


}





customElements.define('cart-item-tool', CartTool);





class CartCancel extends HTMLElement {


  constructor() {


    super();


    


    this.querySelector('button').addEventListener('click',(event) => {


      document.querySelector('.popup-toolDown.show').classList.remove('show');


      document.querySelector('.previewCart').classList.remove('active-tool');


    })


  }


}





customElements.define('cart-cancel-popup', CartCancel);





class CartNote extends HTMLElement {


  constructor() {


    super();


    


    this.querySelector('[data-update-note]').addEventListener('click', (event) => {


      this.val = this.querySelector('.text-area').value;


      const body = JSON.stringify({ note: this.val });


      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});


      document.querySelector('.popup-toolDown.show').classList.remove('show');


      document.querySelector('.previewCart').classList.remove('active-tool');


    })


  }


}





customElements.define('cart-note', CartNote);





class CouponCode extends HTMLElement {


  constructor() {


    super();


    if (localStorage.getItem('storedDiscount')){


      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  


    }


    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {


      this.val = this.querySelector('input[name="discount"]').value;


      localStorage.setItem('storedDiscount', this.val);


      fetch(`/discount/${this.val}`)


          .then((response) => response.text())


          .then((responseText) => {


        	


      });


      document.querySelector('.popup-toolDown.show').classList.remove('show');


      document.querySelector('.previewCart').classList.remove('active-tool');


      Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});


    })


  }


}





customElements.define('coupon-code', CouponCode);

(function(){
  if (window.__svhubCartDrawerFinal) return;
  window.__svhubCartDrawerFinal = true;

  var TEXT = {
    add: 'A\u00f1adir',
    adding: 'A\u00f1adiendo...',
    added: 'A\u00f1adido',
    freeShipping: '\u00a1Llegaste a env\u00edo gratis!'
  };

  var ROUTINES = [
    {
      id: 'omega',
      label: 'Omega',
      cart: /omega|dha|epa|3\s*-?\s*6\s*-?\s*9|pescado/,
      include: [/magnesio|magnesium/, /vitamina\s*d|d3\b/, /colageno|collagen/, /coenzima|q10|coq10/, /zinc/],
      avoid: /omega|dha|epa|3\s*-?\s*6\s*-?\s*9/,
      reason: 'ideal con omega'
    },
    {
      id: 'sleep',
      label: 'Sue\u00f1o',
      cart: /sueno|sue\u00f1o|dormir|descanso|calma|melatonina|tirosina|l-tirosina|ashwagandha|relax/,
      include: [/magnesio|magnesium/, /tirosina|l-tirosina/, /ashwagandha/, /melatonina/, /complejo\s*b|vitamina\s*b/],
      avoid: /sueno|sue\u00f1o|dormir|descanso|calma|melatonina/,
      reason: 'apoya tu descanso'
    },
    {
      id: 'woman',
      label: 'Mujer',
      cart: /mujer|inositol|vitaglow|biotina|piel|cabello|unas|u\u00f1as|hormonal|hialuronico/,
      include: [/inositol/, /vitaglow|biotina/, /colageno|collagen/, /omega|dha|epa/, /vitamina\s*d|d3\b/, /magnesio/],
      avoid: /mujer|inositol|vitaglow/,
      reason: 'rutina femenina'
    },
    {
      id: 'beauty',
      label: 'Belleza',
      cart: /piel|cabello|unas|u\u00f1as|biotina|hialuronico|colageno|vitaglow/,
      include: [/colageno|collagen/, /vitaglow|biotina/, /vitamina\s*c/, /omega|dha|epa/, /hialuronico/],
      avoid: /piel|cabello|unas|u\u00f1as|biotina|hialuronico/,
      reason: 'piel y cabello'
    },
    {
      id: 'energy',
      label: 'Energ\u00eda',
      cart: /energia|energ\u00eda|cansancio|tirosina|l-tirosina|b12|complejo\s*b|ginseng|q10|coq10/,
      include: [/tirosina|l-tirosina/, /complejo\s*b|vitamina\s*b|b12/, /magnesio/, /q10|coq10/, /ginseng/],
      avoid: /energia|energ\u00eda|tirosina|b12|complejo\s*b/,
      reason: 'energia diaria'
    },
    {
      id: 'immune',
      label: 'Defensas',
      cart: /inmun|defensa|vitamina\s*c|zinc|d3\b|vitamina\s*d/,
      include: [/zinc/, /vitamina\s*c/, /vitamina\s*d|d3\b/, /omega|dha|epa/, /probiotico|probioticos/],
      avoid: /inmun|defensa|vitamina\s*c|zinc/,
      reason: 'apoya defensas'
    },
    {
      id: 'digestion',
      label: 'Digesti\u00f3n',
      cart: /digest|probiotico|probioticos|fibra|colon|enzima|flora|jengibre|curcuma/,
      include: [/probiotico|probioticos/, /fibra/, /enzima/, /jengibre|curcuma/, /magnesio/],
      avoid: /digest|probiotico|fibra|colon/,
      reason: 'bienestar digestivo'
    },
    {
      id: 'joints',
      label: 'Huesos',
      cart: /hueso|articul|colageno|calcio|glucosamina|cartilago|luteina/,
      include: [/colageno|collagen/, /calcio/, /vitamina\s*d|d3\b/, /omega|dha|epa/, /magnesio/],
      avoid: /hueso|articul|colageno|calcio/,
      reason: 'soporte articular'
    },
    {
      id: 'men',
      label: 'Hombre',
      cart: /hombre|masculina|prostata|pr\u00f3stata|testosterona/,
      include: [/zinc/, /omega|dha|epa/, /magnesio/, /vitamina\s*d|d3\b/, /saw\s*palmetto/],
      avoid: /hombre|masculina|prostata/,
      reason: 'rutina masculina'
    },
    {
      id: 'sport',
      label: 'Deporte',
      cart: /proteina|creatina|bcaa|glutamina|beta\s*alanina|aminoacido|pre\s*workout|musculo|masa\s*muscular|deport|fitness/,
      include: [/creatina/, /bcaa|aminoacido/, /glutamina/, /beta\s*alanina/, /arginina|citrulina/, /proteina/, /magnesio/],
      reason: 'rendimiento y musculo'
    },
    {
      id: 'weight',
      label: 'Control de peso',
      cart: /cla|carnitina|cetonas|garcinia|quema|adelgaz|control\s*de\s*peso|te\s*verde|cromo|metabolismo/,
      include: [/cla/, /carnitina/, /cetonas/, /te\s*verde/, /garcinia/, /picolinato|cromo/, /fibra/],
      reason: 'control de peso'
    },
    {
      id: 'focus',
      label: 'Concentración',
      cart: /nootropico|concentracion|memoria|teanina|tirosina|cerebro|brilliant|enfoque|cafeina|mental/,
      include: [/teanina/, /tirosina/, /complejo\s*b|vitamina\s*b/, /nootropico|brilliant/, /ginkgo/, /omega|dha|epa/],
      reason: 'enfoque mental'
    },
    {
      id: 'antiox',
      label: 'Antioxidantes',
      cart: /antioxidante|detox|espirulina|chlorella|moringa|astaxantina|clorofila|resveratrol|te\s*verde|alga/,
      include: [/astaxantina/, /espirulina/, /chlorella/, /moringa/, /te\s*verde/, /curcuma/, /resveratrol/],
      reason: 'antioxidante'
    },
    {
      id: 'vision',
      label: 'Visión',
      cart: /luteina|zeaxantina|vista|ojos|vision|ocular/,
      include: [/luteina/, /zeaxantina/, /omega|dha|epa/, /vitamina\s*a/, /arandano/],
      reason: 'salud visual'
    },
    {
      id: 'curves',
      label: 'Realce',
      cart: /aguaje|fenogreco|maca|gluteo|curvas|realce/,
      include: [/aguaje/, /fenogreco/, /maca/, /colageno/],
      reason: 'realce natural'
    }
  ];

  function normalize(value){
    var text = (value || '').toString().toLowerCase();
    try {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (e) {}
    return text;
  }

  function cartContext(){
    var parts = [];
    document.querySelectorAll('.halo-cart-sidebar .previewCartItem-name .text').forEach(function(node){
      parts.push(node.textContent || '');
    });
    document.querySelectorAll('.halo-cart-sidebar .previewCartItem-options, .halo-cart-sidebar .cart-item-properties').forEach(function(node){
      parts.push(node.textContent || '');
    });
    return normalize(parts.join(' '));
  }

  function detectedRules(context){
    return ROUTINES.filter(function(rule){ return rule.cart.test(context); });
  }

  function cardText(card){
    return normalize([
      card.getAttribute('data-title'),
      card.getAttribute('data-handle'),
      card.getAttribute('data-tags')
    ].join(' '));
  }

  function scoreCard(card, rules, missing){
    var text = cardText(card);
    var price = parseInt(card.getAttribute('data-price-cents'), 10) || 0;
    var score = 6;
    var matches = [];
    var reason = '';

    rules.forEach(function(rule){
      var matchedRule = false;
      rule.include.forEach(function(pattern){
        if (pattern.test(text)) {
          score += 26;
          matchedRule = true;
        }
      });
      if (matchedRule) {
        matches.push(rule.id);
        if (!reason) reason = rule.reason;
      }
      if (rule.avoid && rule.avoid.test(text)) score -= 34;
    });

    if (/mas-vendidos|top|favorito|best/.test(text)) score += 6;
    if (/oferta|ofertas|promo|descuento/.test(text)) score += 7;
    if (/nuevo|nuevos/.test(text)) score += 3;

    if (!reason) {
      if (/oferta|ofertas|promo|descuento/.test(text)) reason = 'en oferta';
      else if (/mas-vendidos|top|favorito/.test(text)) reason = 'favorito de clientes';
      else reason = 'complemento diario';
    }

    return { card: card, score: score, matches: matches, reason: reason };
  }

  function renderRoutineBox(box){
    var cards = Array.prototype.slice.call(box.querySelectorAll('[data-sv-reco-card]'));
    if (!cards.length) {
      box.hidden = true;
      return;
    }

    var context = cartContext();
    var rules = detectedRules(context);
    var missing = parseInt(box.getAttribute('data-missing'), 10) || 0;
    var scored = cards.map(function(card){ return scoreCard(card, rules, missing); })
      .filter(function(item){ return item.score > -10; })
      .sort(function(a, b){ return b.score - a.score; });

    function hasVisibleMatch(filterId){
      return scored.some(function(item){ return item.matches.indexOf(filterId) !== -1; });
    }

    var filters = [{ id: 'all', label: 'Para ti' }];
    // Ordenar las categorías por RELEVANCIA: las que tienen más productos
    // recomendados disponibles aparecen primero (después de "Para ti").
    rules.map(function(rule){
      return { rule: rule, count: scored.filter(function(it){ return it.matches.indexOf(rule.id) !== -1; }).length };
    }).filter(function(r){
      return r.count > 0;
    }).sort(function(a, b){
      return b.count - a.count;
    }).forEach(function(r){
      if (!filters.some(function(filter){ return filter.id === r.rule.id; })) {
        filters.push({ id: r.rule.id, label: r.rule.label });
      }
    });

    var current = box.getAttribute('data-sv-filter') || 'all';
    if (!filters.some(function(filter){ return filter.id === current; })) current = 'all';

    var menu = box.querySelector('[data-svhub-routine-menu]');
    if (menu) {
      var chipsHtml = filters.map(function(filter){
        return '<button type="button" role="tab" aria-selected="' + (filter.id === current ? 'true' : 'false') + '" class="svhub-routine-chip' + (filter.id === current ? ' is-active' : '') + '" data-sv-routine-filter="' + filter.id + '">' + filter.label + '</button>';
      }).join('');
      // Reconstruir SOLO si cambió. El MutationObserver global dispara renderRoutineBox
      // muy seguido (cada tick del contador re-renderiza); reconstruir el menú en cada
      // pasada DESTRUYE los chips entre mousedown/mouseup y los clics se pierden.
      if (menu.innerHTML !== chipsHtml) menu.innerHTML = chipsHtml;
    }

    var visible = scored.filter(function(item){
      return current === 'all' || item.matches.indexOf(current) !== -1;
    });

    if (!visible.length && current !== 'all') {
      current = 'all';
      box.setAttribute('data-sv-filter', current);
      visible = scored;
      if (menu) {
        menu.querySelectorAll('[data-sv-routine-filter]').forEach(function(btn){
          btn.classList.toggle('is-active', btn.getAttribute('data-sv-routine-filter') === 'all');
        });
      }
    }

    // Variedad por chip: con un chip activo, priorizar los productos MÁS específicos
    // de ESE chip (los que matchean menos categorías). Así cada chip muestra productos
    // distintos en su top, en vez de repetir siempre los mismos multi-match genéricos.
    if (current !== 'all') {
      visible = visible.slice().sort(function(a, b){
        var ax = a.matches.filter(function(m){ return m !== 'shipping' && m !== current; }).length;
        var bx = b.matches.filter(function(m){ return m !== 'shipping' && m !== current; }).length;
        if (ax !== bx) return ax - bx;   // menos categorías extra = más específico = primero
        return b.score - a.score;        // desempate por puntaje
      });
    }

    // Firma del estado deseado (filtro + qué cards visibles, en qué orden).
    // El MutationObserver global re-ejecuta renderRoutineBox cada tick del contador;
    // si el resultado no cambió, NO tocar el DOM -> sin parpadeo y sin bucle de re-render.
    var visibleCards = visible.slice(0, 12).map(function(it){ return it.card; });
    var sig = current + '|' + visibleCards.map(function(c){ return cards.indexOf(c); }).join(',');
    if (box.__svhubRenderSig !== sig) {
      box.__svhubRenderSig = sig;

      cards.forEach(function(card){
        var hide = visibleCards.indexOf(card) === -1;
        if (card.hidden !== hide) card.hidden = hide;
      });
      visible.slice(0, 12).forEach(function(item, index){
        var reason = item.card.querySelector('[data-sv-reco-reason]');
        if (reason && reason.textContent !== item.reason) reason.textContent = item.reason;
        var ord = String(index);
        if (item.card.style.order !== ord) item.card.style.order = ord;
      });

      var grid = box.querySelector('[data-svhub-routine-grid]');
      if (grid) grid.scrollTo({ left: 0, behavior: 'auto' });

      if (menu) {
        var active = menu.querySelector('.svhub-routine-chip.is-active');
        if (active) {
          window.setTimeout(function(){
            // Centrar el chip activo SOLO en su carrusel horizontal (scrollLeft).
            // NO usar scrollIntoView: arrastra el scroll vertical del drawer.
            var left = active.offsetLeft - Math.max(0, (menu.clientWidth - active.offsetWidth) / 2);
            menu.scrollLeft = Math.max(0, left);
          }, 40);
        }
      }

      window.setTimeout(function(){
        try { window.dispatchEvent(new Event('resize')); } catch (e) {}
      }, 80);
    }

    var boxHidden = visible.length === 0;
    if (box.hidden !== boxHidden) box.hidden = boxHidden;
  }

  function initRoutineRecs(){
    document.querySelectorAll('[data-svhub-routine-recs]').forEach(renderRoutineBox);
    rewriteFreeShippingMessage();
  }

  function refreshDrawer(){
    return fetch('/cart?view=ajax_side_cart', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function(response){ return response.text(); })
      .then(function(html){
        var wrapper = document.querySelector('.previewCart-wrapper');
        if (!wrapper || !html) return;
        wrapper.innerHTML = html;
        runInsertedScripts(wrapper);
        document.body.classList.add('cart-sidebar-show');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        initRoutineRecs();
        updateCartCount();
      });
  }

  function updateCartCount(){
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(response){ return response.json(); })
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(node){
          node.textContent = cart.item_count >= 100 ? '99+' : cart.item_count;
        });
        normalizeCartHeaderText(cart.item_count);
      })
      .catch(function(){});
  }

  function normalizeCartHeaderText(count){
    var parsed = typeof count === 'number' ? count : parseInt((document.querySelector('#halo-cart-sidebar [data-cart-count]') || {}).textContent, 10);
    var label = parsed === 1 ? 'producto agregado' : 'productos agregados';
    document.querySelectorAll('#halo-cart-sidebar [data-cart-text]').forEach(function(node){
      node.textContent = label;
    });
  }

  function runInsertedScripts(root){
    root.querySelectorAll('script:not([data-svhub-executed])').forEach(function(oldScript){
      var script = document.createElement('script');
      Array.prototype.slice.call(oldScript.attributes).forEach(function(attr){
        script.setAttribute(attr.name, attr.value);
      });
      script.setAttribute('data-svhub-executed', 'true');
      script.text = oldScript.textContent || '';
      oldScript.parentNode.replaceChild(script, oldScript);
    });
  }

  function bindAddButtons(){
    if (window.__svhubRoutineAddBound) return;
    window.__svhubRoutineAddBound = true;
    document.addEventListener('click', function(event){
      if (!event.target || !event.target.closest) return;
      var button = event.target.closest('[data-sv-add-btn]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      var card = button.closest('[data-variant-id]');
      var variantId = card && card.getAttribute('data-variant-id');
      if (!variantId || button.getAttribute('aria-busy') === 'true') return;

      button.setAttribute('aria-busy', 'true');
      button.textContent = TEXT.adding;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function(response){
          if (!response.ok) throw new Error('cart add failed');
          return response.json();
        })
        .then(function(){
          button.textContent = TEXT.added;
          return refreshDrawer();
        })
        .catch(function(error){
          console.error('[svhub cart drawer]', error);
          button.textContent = 'Error';
        })
        .then(function(){
          setTimeout(function(){
            button.removeAttribute('aria-busy');
            button.textContent = TEXT.add;
          }, 900);
        });
    }, true);
  }

  function bindRoutineFilters(){
    if (window.__svhubRoutineFilterBound) return;
    window.__svhubRoutineFilterBound = true;
    document.addEventListener('click', function(event){
      if (!event.target || !event.target.closest) return;
      var chip = event.target.closest('[data-sv-routine-filter]');
      if (!chip) return;
      var menu = chip.closest('[data-svhub-routine-menu]');
      if (menu && menu.__svhubSuppressClick) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      var box = chip.closest('[data-svhub-routine-recs]');
      if (!box) return;
      box.setAttribute('data-sv-filter', chip.getAttribute('data-sv-routine-filter') || 'all');
      renderRoutineBox(box);
    });
  }

  function initRoutineMenuScroll(){
    document.querySelectorAll('.halo-cart-sidebar [data-svhub-routine-menu]').forEach(function(menu){
      if (menu.__svhubMenuScrollBound) return;
      menu.__svhubMenuScrollBound = true;

      var startX = 0;
      var startScroll = 0;
      var dragging = false;
      var moved = false;

      menu.addEventListener('pointerdown', function(event){
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (menu.scrollWidth <= menu.clientWidth + 2) return;
        startX = event.clientX;
        startScroll = menu.scrollLeft;
        dragging = true;
        moved = false;
        // NO capturar el puntero aquí: con setPointerCapture el evento 'click' cae
        // sobre 'menu' y el handler del chip (que busca con closest hacia arriba) no
        // lo encuentra -> los chips no responden. Se captura al iniciar el drag real.
      });

      menu.addEventListener('pointermove', function(event){
        if (!dragging) return;
        var dx = event.clientX - startX;
        if (Math.abs(dx) > 4 && !moved) {
          moved = true;
          menu.classList.add('is-dragging');
          if (event.pointerType === 'mouse' && menu.setPointerCapture) {
            try { menu.setPointerCapture(event.pointerId); } catch(e) {}
          }
        }
        if (!moved) return;
        event.preventDefault();
        menu.scrollLeft = startScroll - dx;
      });

      function finish(event){
        if (!dragging) return;
        dragging = false;
        menu.classList.remove('is-dragging');
        if (moved) {
          menu.__svhubSuppressClick = true;
          window.setTimeout(function(){ menu.__svhubSuppressClick = false; }, 160);
        }
        if (event && event.pointerId && menu.releasePointerCapture) {
          try { menu.releasePointerCapture(event.pointerId); } catch(e) {}
        }
      }

      menu.addEventListener('pointerup', finish);
      menu.addEventListener('pointercancel', finish);
      menu.addEventListener('pointerleave', finish);
    });
  }

  function rewriteFreeShippingMessage(){
    var box = document.querySelector('[data-svhub-routine-recs]');
    normalizeShippingBanner();
    if (!box) return;
    var missing = parseInt(box.getAttribute('data-missing'), 10) || 0;
    if (missing <= 0) {
      document.querySelectorAll('.halo-cart-sidebar [data-shipping-message]').forEach(function(node){
        node.innerHTML = '<strong>' + TEXT.freeShipping + '</strong>';
        node.setAttribute('data-svhub-shipping-normalized', 'free');
      });
    }
  }

  function normalizeShippingBanner(){
    document.querySelectorAll('.halo-cart-sidebar [data-shipping-message]').forEach(function(node){
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;

      if (/llegaste|env[ií]o gratis aplicado|sin costo|tienes env[ií]o gratis/i.test(text)) {
        node.innerHTML = '<strong>' + TEXT.freeShipping + '</strong>';
        node.setAttribute('data-svhub-shipping-normalized', 'free');
        return;
      }

      var amount = text.match(/\$\s*[\d,.]+(?:\s*MXN)?/i);
      if (amount) {
        var formatted = amount[0].replace(/\$\s+/, '$').replace(/\s*MXN/i, ' MXN');
        node.innerHTML = '<strong>Env&iacute;o gratis</strong><span>Faltan ' + formatted + '</span>';
        node.setAttribute('data-svhub-shipping-normalized', 'missing');
      }
    });
  }

  function closeDrawer(drawer){
    drawer.style.transform = '';
    var close = drawer.querySelector('[data-close-cart-sidebar]');
    if (close) close.click();
    else document.body.classList.remove('cart-sidebar-show');
  }

  function initSwipeClose(){
    var drawer = document.getElementById('halo-cart-sidebar');
    if (!drawer || drawer.__svhubSwipeBound) return;
    drawer.__svhubSwipeBound = true;
    var mobileSwipeQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

    function canSwipeClose(){
      return mobileSwipeQuery ? mobileSwipeQuery.matches : window.innerWidth <= 749;
    }

    var startX = 0;
    var startY = 0;
    var lastX = 0;
    var active = false;
    var dragging = false;

    drawer.addEventListener('pointerdown', function(event){
      if (!canSwipeClose()) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('button, a, input, textarea, select, .svhub-routine-grid, .svhub-routine-menu, .previewCartItem-qty')) return;
      startX = event.clientX;
      startY = event.clientY;
      lastX = startX;
      active = true;
      dragging = false;
      drawer.style.transition = 'none';
    });

    drawer.addEventListener('pointermove', function(event){
      if (!active) return;
      if (!canSwipeClose()) {
        active = false;
        dragging = false;
        drawer.style.transition = '';
        drawer.style.transform = '';
        return;
      }
      var dx = event.clientX - startX;
      var dy = Math.abs(event.clientY - startY);
      lastX = event.clientX;
      if (dx > 8 && dx > dy + 6) dragging = true;
      if (!dragging) return;
      drawer.style.transform = 'translate3d(' + Math.max(0, dx) + 'px,0,0)';
    });

    function finish(){
      if (!active) return;
      if (!canSwipeClose()) {
        active = false;
        dragging = false;
        drawer.style.transition = '';
        drawer.style.transform = '';
        return;
      }
      var dx = lastX - startX;
      active = false;
      drawer.style.transition = '';
      if (dragging && dx > 92) {
        closeDrawer(drawer);
      } else {
        drawer.style.transform = '';
      }
      dragging = false;
    }

    drawer.addEventListener('pointerup', finish);
    drawer.addEventListener('pointercancel', finish);
  }

  function initRoutineArrowScroll(){
    document.querySelectorAll('.halo-cart-sidebar [data-svhub-routine-scroll]').forEach(function(box){
      if (box.__svhubArrowScrollBound) return;
      box.__svhubArrowScrollBound = true;

      var grid = box.querySelector('[data-svhub-routine-grid]');
      var routine = box.closest('[data-svhub-routine-recs]') || box;
      var prev = routine.querySelector('[data-sv-routine-prev]');
      var next = routine.querySelector('[data-sv-routine-next]');
      if (!grid || !prev || !next) return;

      function update(){
        var max = Math.max(0, grid.scrollWidth - grid.clientWidth);
        var atStart = grid.scrollLeft <= 8;
        var atEnd = grid.scrollLeft >= (max - 8);
        var canScroll = max > 6;

        prev.hidden = !canScroll;
        next.hidden = !canScroll;
        prev.disabled = !canScroll || atStart;
        next.disabled = !canScroll || atEnd;
        prev.setAttribute('aria-disabled', prev.disabled ? 'true' : 'false');
        next.setAttribute('aria-disabled', next.disabled ? 'true' : 'false');
      }

      function move(dir){
        var card = grid.querySelector('.svhub-routine-card:not([hidden])') || grid.querySelector('.svhub-routine-card');
        var styles = window.getComputedStyle ? window.getComputedStyle(grid) : null;
        var gap = styles ? parseFloat(styles.columnGap || styles.gap || 0) : 0;
        var step = card ? (card.getBoundingClientRect().width + (gap || 0)) : Math.max(150, Math.floor(grid.clientWidth / 2));
        var perPage = Math.max(1, Math.floor((grid.clientWidth + (gap || 0)) / step));
        var max = Math.max(0, grid.scrollWidth - grid.clientWidth);
        var target = grid.scrollLeft + (step * perPage * dir);

        target = Math.round(target / step) * step;
        target = Math.max(0, Math.min(max, target));
        if (target > max - 6) target = max;

        grid.scrollTo({ left: target, behavior: 'smooth' });
        window.setTimeout(update, 260);
      }

      prev.addEventListener('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        if (prev.disabled) return;
        move(-1);
        window.setTimeout(update, 80);
      });

      next.addEventListener('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        if (next.disabled) return;
        move(1);
        window.setTimeout(update, 80);
      });

      grid.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.setTimeout(update, 60);
      window.setTimeout(update, 360);
    });
  }

  function openCartDrawerFallback(){
    document.body.classList.add('cart-sidebar-show');

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function(response){ return response.json(); })
      .then(function(cart){
        if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
          window.sharedFunctions.updateSidebarCart(cart);
        } else {
          return refreshDrawer();
        }
      })
      .catch(function(){
        refreshDrawer();
      });
  }

  function bindCartTriggerFallback(){
    if (window.__svhubCartTriggerFallbackBound) return;
    window.__svhubCartTriggerFallbackBound = true;

    document.addEventListener('click', function(event){
      if (!event.target || !event.target.closest) return;

      var trigger = event.target.closest('[data-cart-sidebar], .header-action--cart, #cart-icon-bubble, .cart-icon-bubble');
      if (!trigger || trigger.closest('#halo-cart-sidebar')) return;

      event.preventDefault();

      window.setTimeout(function(){
        if (!document.body.classList.contains('cart-sidebar-show')) {
          openCartDrawerFallback();
        }
      }, 80);
    });
  }

  function boot(){
    var wrapper = document.querySelector('.previewCart-wrapper');
    if (wrapper) runInsertedScripts(wrapper);
    normalizeCartHeaderText();
    normalizeShippingBanner();
    window.setTimeout(normalizeShippingBanner, 120);
    window.setTimeout(normalizeShippingBanner, 480);
    bindCartTriggerFallback();
    bindAddButtons();
    bindRoutineFilters();
    initRoutineMenuScroll();
    initRoutineRecs();
    initSwipeClose();
    initRoutineArrowScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('cart:refresh', function(){
    setTimeout(boot, 60);
  });

  document.addEventListener('cart-update', function(event){
    var cart = event.detail || {};
    normalizeCartHeaderText(cart.item_count);
    setTimeout(normalizeCartHeaderText, 60);
  });

  if (!window.__svhubCartDrawerObserver) {
    window.__svhubCartDrawerObserver = new MutationObserver(function(){
      window.clearTimeout(window.__svhubCartDrawerObserverTimer);
      window.__svhubCartDrawerObserverTimer = window.setTimeout(boot, 80);
    });
    window.__svhubCartDrawerObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
